import { SharedState } from '$utils/sharedState.svelte';
import dayjs, { type Dayjs } from 'dayjs';

const SOMETHING_WE_CONSIDER_SMOOTH_FPS = 120;

/**
 * Use to synchronize timers across all components:
 */
class GlobalClockState extends SharedState<Dayjs> {
  private _interval: ReturnType<typeof setInterval> | null = null;

  inSeconds = $derived(this.current ? Math.floor(this.current.valueOf() / 1000) : 0);

  start() {
    if (this._interval) {
      clearInterval(this._interval);
    }

    this._interval = setInterval(() => {
      this.set(dayjs());
    }, 1_000 / SOMETHING_WE_CONSIDER_SMOOTH_FPS);
  }
}

export const stateGlobalClock = new GlobalClockState(null);
